/* tslint:disable */
/* eslint-disable */
/**
 * Apperta Physical Health REST API
 * Apperta Physical Health REST API
 *
 * The version of the OpenAPI document: 0.2.0-SNAPSHOT2
 * Contact: info@staircase13.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response rate for particular time period
 * @export
 * @interface ResponseRateDto
 */
export interface ResponseRateDto {
    /**
     * Time period
     * @type {string}
     * @memberof ResponseRateDto
     */
    timePeriod: string;
    /**
     * Percentage response rate
     * @type {number}
     * @memberof ResponseRateDto
     */
    percentage: number;
    /**
     * Total number of responses
     * @type {number}
     * @memberof ResponseRateDto
     */
    totalResponses: number;
}

/**
 * Check if a given object implements the ResponseRateDto interface.
 */
export function instanceOfResponseRateDto(value: object): value is ResponseRateDto {
    if (!('timePeriod' in value) || value['timePeriod'] === undefined) return false;
    if (!('percentage' in value) || value['percentage'] === undefined) return false;
    if (!('totalResponses' in value) || value['totalResponses'] === undefined) return false;
    return true;
}

export function ResponseRateDtoFromJSON(json: any): ResponseRateDto {
    return ResponseRateDtoFromJSONTyped(json, false);
}

export function ResponseRateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseRateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'timePeriod': json['timePeriod'],
        'percentage': json['percentage'],
        'totalResponses': json['totalResponses'],
    };
}

export function ResponseRateDtoToJSON(value?: ResponseRateDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'timePeriod': value['timePeriod'],
        'percentage': value['percentage'],
        'totalResponses': value['totalResponses'],
    };
}

